import { cloneDeep, isEqual } from 'lodash'

import { proxy } from '@/utils'

import render from './render'

export default {
  name: 'UserApiKeys',

  mixins: [ proxy({ type: 'object' }) ],

  props: {
    defaultValue: {
      type: Object,
      default() {
        return {
          key: '',
          value: ''
        }
      }
    }
  },

  data() {
    return {
      revealed: []
    }
  },

  methods: {
    addField() {
      this.proxy.push(cloneDeep(this.defaultValue))
      this.revealed.push(false)
    },
    removeField(index) {
      this.proxy.splice(index, 1)
      this.revealed.splice(index, 1)
      if (this.proxy.length === 0) {
        this.addField()
      }
    },
    toggleVisibility(index) {
      this.$set(this.revealed, index, !this.revealed[index])
    },
    disabledUserIds(index) {
      return this.proxy.reduce((result, item, itemIndex) => {
        if (itemIndex !== index && item.key) {
          result.push(item.key)
        }

        return result
      }, [])
    },

    _inputFilter(data) {
      if (!data) {
        data = {}
      }
      const result = Object.keys(data).reduce((result, key) => {
        result.splice(result.length, 0, {
          key,
          value: data[key]
        })

        return result
      }, [])

      if (result.length === 0) {
        result.splice(0, 0, cloneDeep(this.defaultValue))
      }

      return result
    },
    _outputFilter(data) {
      // Строки без выбранного пользователя наружу не отдаем, иначе ключом
      // объекта становится строка "undefined" или "".
      return data.reduce((result, item) => {
        if (item.key) {
          result[item.key] = item.value
        }

        return result
      }, {})
    },

    receiveValue() {
      // Сравниваем в формате значения свойства: черновые строки живут только
      // в proxy, прямое сравнение proxy с value затирало бы их после emit.
      if (!isEqual(this._outputFilter(this.proxy), this.value)) {
        this.proxy = this._inputFilter(this.value)
      }
      this.revealed = this.proxy.map((item, index) => {
        return this.revealed[index] || false
      })
    },

    transmitValue() {
      const value = this._outputFilter(this.proxy)
      if (!isEqual(value, this.value)) {
        this.$emit('input', value)
      }
    }
  },

  render
}
